import { z } from 'zod';
import {
  ALLOW_AUTO_REGISTER,
  BIG_FILE_STORAGE_DIR,
  COOKIE_POLICY_URL,
  CORS_DOMAIN,
  DEFAULT_MAP,
  EMAIL_ADDRESS,
  EMAIL_LOGIN,
  EMAIL_PASSWORD,
  EMAIL_SMTP_PORT,
  EMAIL_SMTP_SERVER,
  EMAIL_SSL_SERVER,
  LDAP_ADDRESS,
  LDAP_BASE_DN,
  LDAP_BIND_DN,
  LDAP_EMAIL_ATTRIBUTE,
  LDAP_FILTER,
  LDAP_FIRST_NAME_ATTRIBUTE,
  LDAP_LAST_NAME_ATTRIBUTE,
  LDAP_OBJECT_CLASS,
  LDAP_PASSWORD,
  LDAP_PORT,
  LDAP_SSL,
  LDAP_UID,
  LEFT_LOGO_IMG,
  LEFT_LOGO_LINK,
  LEFT_LOGO_TEXT,
  LEGEND_FILE_1,
  LEGEND_FILE_2,
  LEGEND_FILE_3,
  LEGEND_FILE_4,
  MATOMO_URL,
  MAX_COLOR_VAL_NAME_ID,
  MCP_ENABLED,
  MIN_COLOR_VAL_NAME_ID,
  MINERVA_ROOT,
  MINERVANET_AUTH_TOKEN,
  MINERVANET_URL,
  NEUTRAL_COLOR_VAL_NAME_ID,
  ORCID_CLIENT_ID,
  ORCID_CLIENT_SECRET,
  OVERLAY_OPACITY_NAME_ID,
  REQUEST_ACCOUNT_DEFAULT_CONTENT,
  REQUEST_ACCOUNT_DEFAULT_TITLE,
  REQUEST_ACCOUNT_EMAIL,
  REQUIRE_APPROVAL_FOR_AUTO_REGISTERED_USERS,
  RIGHT_LOGO_IMG,
  RIGHT_LOGO_LINK,
  RIGHT_LOGO_TEXT,
  SEARCH_DISTANCE_NAME_ID,
  SESSION_LENGTH,
  SIMPLE_COLOR_VAL_NAME_ID,
  TERMS_OF_SERVICE_ID,
  X_FRAME_DOMAIN,
} from '@/redux/configuration/configuration.constants';

const configurationOptionTypeSchema = z.enum([
  MIN_COLOR_VAL_NAME_ID,
  MAX_COLOR_VAL_NAME_ID,
  SIMPLE_COLOR_VAL_NAME_ID,
  NEUTRAL_COLOR_VAL_NAME_ID,
  OVERLAY_OPACITY_NAME_ID,
  SEARCH_DISTANCE_NAME_ID,
  REQUEST_ACCOUNT_EMAIL,
  TERMS_OF_SERVICE_ID,
  MATOMO_URL,
  COOKIE_POLICY_URL,
  LEFT_LOGO_IMG,
  LEFT_LOGO_LINK,
  LEFT_LOGO_TEXT,
  RIGHT_LOGO_IMG,
  RIGHT_LOGO_LINK,
  RIGHT_LOGO_TEXT,
  MINERVA_ROOT,
  MCP_ENABLED,
  EMAIL_ADDRESS,
  EMAIL_LOGIN,
  EMAIL_PASSWORD,
  EMAIL_SMTP_SERVER,
  EMAIL_SSL_SERVER,
  EMAIL_SMTP_PORT,
  MINERVANET_URL,
  MINERVANET_AUTH_TOKEN,
  DEFAULT_MAP,
  X_FRAME_DOMAIN,
  CORS_DOMAIN,
  BIG_FILE_STORAGE_DIR,
  REQUEST_ACCOUNT_DEFAULT_CONTENT,
  LEGEND_FILE_1,
  LEGEND_FILE_2,
  LEGEND_FILE_3,
  LEGEND_FILE_4,
  LDAP_ADDRESS,
  LDAP_PORT,
  LDAP_SSL,
  LDAP_BIND_DN,
  LDAP_PASSWORD,
  LDAP_BASE_DN,
  LDAP_OBJECT_CLASS,
  LDAP_FIRST_NAME_ATTRIBUTE,
  LDAP_LAST_NAME_ATTRIBUTE,
  LDAP_EMAIL_ATTRIBUTE,
  LDAP_FILTER,
  LDAP_UID,
  SESSION_LENGTH,
  REQUEST_ACCOUNT_DEFAULT_TITLE,
  ORCID_CLIENT_ID,
  ORCID_CLIENT_SECRET,
  ALLOW_AUTO_REGISTER,
  REQUIRE_APPROVAL_FOR_AUTO_REGISTERED_USERS,
]);

const configurationOptionValueTypeSchema = z.enum([
  'STRING',
  'BOOLEAN',
  'EMAIL',
  'COLOR',
  'DOUBLE',
  'TEXT',
  'INTEGER',
  'PASSWORD',
  'URL',
]);

const configurationOptionGroupTypeSchema = z.enum(['Server', 'Access', 'Interface']);

const configurationOptionSubGroupTypeSchema = z.enum([
  'Legend and logo',
  'User registration',
  'Oauth',
  'LDAP',
  'Overlays',
  'Email notification',
  'Advanced',
  'Document links',
  'Content visibility',
  'MCP',
]);

export const configurationOptionSchema = z.object({
  type: configurationOptionTypeSchema,
  valueType: configurationOptionValueTypeSchema,
  commonName: z.string(),
  value: z.string(),
  group: configurationOptionGroupTypeSchema,
  subgroup: configurationOptionSubGroupTypeSchema,
  parameterOrder: z.number(),
});
